var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { dateToTimestamp, timestampToDate } from '../utils';
import TextField from '@mui/material/TextField';
import DatePicker from '@mui/lab/DatePicker';
import { useAccurityTimezone } from '../../timezoneProvider/AccurityTimezoneProvider';
import { InputAdornment } from '@mui/material';
var AccurityDatePicker = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, errorMessage = _a.errorMessage, inputEndAdornment = _a.inputEndAdornment, hideNativePickerButton = _a.hideNativePickerButton, isPickerOpen = _a.isPickerOpen, onPickerClose = _a.onPickerClose;
    var timezone = useAccurityTimezone();
    var handleChange = function (newValue) {
        onChange(dateToTimestamp(newValue, timezone));
    };
    var endAdornment = function (datePickerEndAdornment) { return (React.createElement(InputAdornment, { position: "end" },
        !hideNativePickerButton && datePickerEndAdornment,
        inputEndAdornment)); };
    return (React.createElement(DatePicker, { label: label, value: timestampToDate(value, timezone), onChange: handleChange, disabled: disabled, mask: '____-__-__', inputFormat: 'YYYY-MM-DD', disableHighlightToday: true, open: isPickerOpen, onClose: onPickerClose, renderInput: function (params) {
            var _a;
            return (React.createElement(TextField, __assign({}, params, { error: Boolean(errorMessage), helperText: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.trim(), fullWidth: true, InputProps: {
                    endAdornment: endAdornment((_a = params === null || params === void 0 ? void 0 : params.InputProps) === null || _a === void 0 ? void 0 : _a.endAdornment)
                } })));
        } }));
};
export default AccurityDatePicker;
//# sourceMappingURL=AccurityDatePicker.js.map